<div class="browse-by-category-container">
  
  <!-- Section Title -->
  <h2 class="section-title">{{ sectionTitle }}</h2>
  
  <!-- Error State (Full Width) -->
  <div *ngIf="error && !loadingCategories" class="error-state">
    <div class="error-icon">⚠️</div>
    <p class="error-message">{{ error }}</p>
    <button (click)="loadCategories()" class="retry-button">Retry</button>
  </div>
  
  <!-- Main Layout -->
  <div *ngIf="!error || loadingCategories" class="browse-layout">
    
    <!-- Left Sidebar: Categories -->
    <aside class="category-sidebar">
      
      <!-- Loading State for Categories -->
      <div *ngIf="loadingCategories" class="sidebar-loading">
        <div class="spinner-small"></div>
        <p>Loading categories...</p>
      </div>
      
      <!-- Category List -->
      <nav *ngIf="!loadingCategories" class="category-list">
        <button
          *ngFor="let category of categories; trackBy: trackByCategoryId"
          class="category-item"
          [class.active]="category.id === selectedCategory?.id"
          (click)="selectCategory(category)"
          [attr.aria-current]="category.id === selectedCategory?.id ? 'true' : null"
          [attr.aria-label]="category.name + (category.id === selectedCategory?.id ? ' (selected)' : '')">
          
          <!-- Active indicator bar -->
          <div *ngIf="category.id === selectedCategory?.id" class="active-indicator" aria-hidden="true"></div>
          
          <div class="category-content">
            <span class="category-name">{{ category.name }}</span>
            
            <!-- Arrow icon for selected -->
            <svg *ngIf="category.id === selectedCategory?.id" class="category-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M6.69 20.48L8.099 21.9L18 12L8.099 2.10003L6.69 3.52003L15.169 12L6.69 20.48Z" fill="#0600B4"/>
            </svg>
          </div>
        </button>
      </nav>
      
      <!-- Empty State for Sidebar -->
      <div *ngIf="!loadingCategories && categories.length === 0" class="sidebar-empty">
        <p>No categories available</p>
      </div>
      
    </aside>
    
    <!-- Right Content: Article Preview -->
    <main class="articles-preview">
      
      <!-- Loading State for Articles -->
      <div *ngIf="loadingArticles" class="loading-state">
        <div class="spinner"></div>
        <p>Loading articles...</p>
      </div>
      
      <!-- Articles Grid -->
      <div *ngIf="!loadingArticles && previewArticles.length > 0" class="articles-grid">
        <article-card
          *ngFor="let article of previewArticles; trackBy: trackByArticleId"
          [article]="article"
          [variant]="'browse'">
        </article-card>
      </div>
      
      <!-- Empty State for Articles -->
      <div *ngIf="!loadingArticles && previewArticles.length === 0 && selectedCategory" class="empty-state">
        <div class="empty-icon">📭</div>
        <p>No articles available for <strong>{{ selectedCategory.name }}</strong></p>
      </div>
      
      <!-- Pagination Controls (Prev | View All | Next) -->
      <div *ngIf="!loadingArticles && previewArticles.length > 0 && selectedCategory" class="pagination-controls">
        <!-- Previous Button (only show if navigation arrows needed) -->
        <button 
          *ngIf="showNavigationArrows"
          class="nav-button prev-button" 
          [disabled]="!canNavigatePrev"
          (click)="navigatePrev()"
          aria-label="Show previous article">
          <svg width="32" height="24" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M0.439341 12.1066C-0.146446 11.5208 -0.146446 10.571 0.439341 9.98524L9.98528 0.439297C10.5711 -0.14649 11.5208 -0.14649 12.1066 0.439297C12.6924 1.02508 12.6924 1.97483 12.1066 2.56062L3.62132 11.0459L12.1066 19.5312C12.6924 20.117 12.6924 21.0667 12.1066 21.6525C11.5208 22.2383 10.5711 22.2383 9.98528 21.6525L0.439341 12.1066ZM32 11.0459V12.5459H1.5V11.0459V9.5459H32V11.0459Z" [attr.fill]="canNavigatePrev ? '#0600B4' : '#CCC'"/>
          </svg>
        </button>
        
        <!-- View All Link -->
        <a 
          [href]="viewAllUrl" 
          class="view-all-link"
          [attr.aria-label]="'View all articles in ' + selectedCategory.name">
          View All
        </a>
        
        <!-- Next Button (only show if navigation arrows needed) -->
        <button 
          *ngIf="showNavigationArrows"
          class="nav-button next-button" 
          [disabled]="!canNavigateNext"
          (click)="navigateNext()"
          aria-label="Show next article">
          <svg width="32" height="24" viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M31.5607 12.1066C32.1464 11.5208 32.1464 10.571 31.5607 9.98524L21.0147 0.439297C20.4289 -0.14649 19.4792 -0.14649 18.8934 0.439297C18.3076 1.02508 18.3076 1.97483 18.8934 2.56062L27.3787 11.0459L18.8934 19.5312C18.3076 20.117 18.3076 21.0667 18.8934 21.6525C19.4792 22.2383 20.4289 22.2383 21.0147 21.6525L31.5607 12.1066ZM0 11.0459V12.5459H30.5V11.0459V9.5459H0V11.0459Z" [attr.fill]="canNavigateNext ? '#0600B4' : '#CCC'"/>
          </svg>
        </button>
      </div>
      
    </main>
    
  </div>
  
</div>
